import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[typedTemplate]',
})
export class TypedTemplateDirective<T> {
  @Input() typedTemplate: T;

  constructor(private contentTemplate: TemplateRef<T>) {}

  static ngTemplateContextGuard<T>(dir: TypedTemplateDirective<T>, ctx: unknown): ctx is T {
    return true;
  }
}
